/*
 * RUFU: レコメンド（同じ香り／Search & Discovery の related）＋カート追加ボタン
 *
 * <reco-products product-ids="1,2" product-handles="a,b" logic="scent" exclude-ids="1,2" limit="4">
 *   基準の商品ごとにカードを取得し、重複とカート内商品を除いて limit 件を [data-reco-list] に差し込む。0件なら要素ごと隠す。
 *   - logic="scent"（Aíam の既定）: /products/<handle>?section_id=reco-scent-items で同じ香り（チャプター番号）の別商品。
 *     番号が取れない商品・同じ香りの商品がない商品は related に切り替える
 *   - logic="related": /recommendations/products?intent=related&section_id=reco-items（Search & Discovery）
 *
 * <reco-add-button>
 *   中の form（/cart/add）を Ajax で送信する。テーマの product-form と違い、cart_type=page でも
 *   カートページへ遷移しない（商品ページで2点続けて追加できるようにするため）。
 *   - カートページ上: 追加後にページを再読み込み（Aíam/eimy のカートは Liquid 描画のため）
 *   - それ以外: cart:change を発火（カートアイコンの件数・カートドロワーが更新される）
 *
 * レコメンド経由の売上の計測
 *   - 商品行のプロパティ _reco: レコメンドから入った商品に付く。値は「枠_経路」
 *       枠: product（商品ページ）/ cart（カートページ）/ drawer（カートドロワー）
 *       経路: add（カードのボタンで追加）/ quick（カードからクイック購入）/ click（カードから商品ページへ移って追加）
 *     先頭が _ のプロパティはカート・チェックアウトでお客様に見えない（line-item の表示で除外済み）。注文の商品行には残る
 *   - カート属性 _reco_touched: レコメンド経由の商品を1点でも追加したカートに付く（注文単位で間接効果を測る用）
 *   click は、カードのリンクを押した商品IDを localStorage に24時間残し、その商品ページでカートに入れたときに付ける。
 *   テーマ内のカート追加は経路が複数ある（product-form・main-product の独自処理・追従バー）ため、/cart/add.js への fetch で付ける
 */
(() => {
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  const RECO_PROP = 'properties[_reco]';
  const CLICK_KEY = 'rufu_reco_clicks';
  const CLICK_TTL = 24 * 60 * 60 * 1000;

  const readClicks = () => {
    try {
      const clicks = JSON.parse(localStorage.getItem(CLICK_KEY) || '{}');
      const now = Date.now();
      Object.keys(clicks).forEach((id) => { if (!clicks[id] || now - clicks[id].at > CLICK_TTL) delete clicks[id]; });
      return clicks;
    } catch (e) {
      return {};
    }
  };

  const saveClick = (productId, value) => {
    try {
      const clicks = readClicks();
      clicks[productId] = { value, at: Date.now() };
      localStorage.setItem(CLICK_KEY, JSON.stringify(clicks));
    } catch (e) {}
  };

  const contextOf = (el) => {
    const card = el.closest('[data-reco-context]');
    return (card && card.getAttribute('data-reco-context')) || 'product';
  };

  // カードのリンク（画像・商品名・商品ページへのボタン）を押したら、商品ページでの追加に click を付けるために残す
  document.addEventListener('click', (event) => {
    const link = event.target.closest && event.target.closest('[data-reco-card] a[href]');
    if (!link) return;
    const card = link.closest('[data-reco-card]');
    saveClick(card.getAttribute('data-product-id'), `${contextOf(card)}_click`);
  }, true);

  // カード内のフォーム（その場で追加・クイック購入）は、送信の前に hidden の _reco を入れる
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!form.matches || !form.matches('form[action*="/cart/add"]') || !form.closest('[data-reco-card]')) return;
    let input = form.querySelector(`input[name="${RECO_PROP}"]`);
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = RECO_PROP;
      form.appendChild(input);
    }
    input.value = `${contextOf(form)}_${form.closest('reco-add-button') ? 'add' : 'quick'}`;
  }, true);

  // 商品ページ: レコメンドから来た商品なら、その商品のバリエーションIDに click の値を対応させる
  const clickedVariants = (() => {
    const map = new Map();
    const product = window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product;
    if (!product) return map;
    const click = readClicks()[String(product.id)];
    if (!click) return map;
    (product.variants || []).forEach((v) => map.set(String(v.id), click.value));
    return map;
  })();

  // /cart/add.js の本文に _reco を足し、付いていれば追加の成功後にカート属性 _reco_touched を付ける
  const tagAddBody = (body) => {
    if (body instanceof FormData || body instanceof URLSearchParams) {
      if (!body.has(RECO_PROP)) {
        const value = clickedVariants.get(String(body.get('id')));
        if (value) body.set(RECO_PROP, value);
      }
      return { body, value: body.get(RECO_PROP) };
    }
    if (typeof body !== 'string') return { body, value: null };

    let json = null;
    try { json = JSON.parse(body); } catch (e) {}
    if (json && typeof json === 'object') {
      let value = null;
      (Array.isArray(json.items) ? json.items : [json]).forEach((item) => {
        if (!item || typeof item !== 'object') return;
        item.properties = item.properties || {};
        if (!item.properties._reco && clickedVariants.has(String(item.id))) item.properties._reco = clickedVariants.get(String(item.id));
        value = value || item.properties._reco || null;
        if (!Object.keys(item.properties).length) delete item.properties;
      });
      return { body: JSON.stringify(json), value };
    }

    const params = new URLSearchParams(body);
    const tagged = tagAddBody(params);
    return { body: tagged.value ? params.toString() : body, value: tagged.value };
  };

  const markCart = (value) => {
    window.fetch(`${root}cart/update.js`, {
      method: 'POST',
      keepalive: true,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { _reco_touched: value } })
    }).catch(() => {});
  };

  if (!window.__rufuRecoFetch) {
    window.__rufuRecoFetch = true;
    const originalFetch = window.fetch;
    window.fetch = function (input, init) {
      let value = null;
      try {
        const url = typeof input === 'string' ? input : (input && input.url) || '';
        const method = ((init && init.method) || 'GET').toUpperCase();
        if (method === 'POST' && url.indexOf('/cart/add') !== -1 && init && init.body) {
          const tagged = tagAddBody(init.body);
          init.body = tagged.body;
          value = tagged.value;
        }
      } catch (e) {}

      const promise = originalFetch.apply(this, arguments);
      if (!value) return promise;
      return promise.then((response) => {
        if (response.ok) markCart(value);
        return response;
      });
    };
  }

  class RecoProducts extends HTMLElement {
    connectedCallback() {
      if (this._loaded) return;
      this._loaded = true;
      this.load();
    }

    async load() {
      const ids = (this.getAttribute('product-ids') || '').split(',').map((s) => s.trim()).filter(Boolean).slice(0, 3);
      const handles = (this.getAttribute('product-handles') || '').split(',').map((s) => s.trim());
      const logic = this.getAttribute('logic') || 'related';
      const exclude = new Set((this.getAttribute('exclude-ids') || '').split(',').map((s) => s.trim()).filter(Boolean));
      const limit = parseInt(this.getAttribute('limit') || '4', 10);
      const list = this.querySelector('[data-reco-list]');

      if (ids.length === 0 || !list) return this.hideSelf();

      // 商品名の語で除外する設定があるとき（title-exclusions）は、描画用セクションがカードを間引くので、related を上限の10件まで取る
      const fetchLimit = this.hasAttribute('title-exclusions') ? 10 : Math.min(10, limit + exclude.size + 2);
      // 同じ香りのカードは data-reco-group（商品タイプ）ごとに1つずつ交互に並べる。グループの順は最初に出てきた順。
      // 基準の商品と同じ商品タイプ（data-reco-same-group）は最後にまとめる
      const interleaveGroups = (cards) => {
        if (!cards.some((card) => card.hasAttribute('data-reco-group'))) return cards;
        const same = cards.filter((card) => card.hasAttribute('data-reco-same-group'));
        const others = cards.filter((card) => !card.hasAttribute('data-reco-same-group'));
        const groups = new Map();
        others.forEach((card) => {
          const key = card.getAttribute('data-reco-group') || '';
          if (!groups.has(key)) groups.set(key, []);
          groups.get(key).push(card);
        });
        const lists = Array.from(groups.values());
        const sorted = [];
        for (let i = 0; sorted.length < others.length; i++) {
          lists.forEach((list) => { if (list[i]) sorted.push(list[i]); });
        }
        return sorted.concat(same);
      };

      const fetchCards = async (url) => {
        try {
          const res = await fetch(url, { priority: 'low' });
          if (!res.ok) return null;
          const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
          if (doc.querySelector('[data-reco-fallback]')) return null;
          return interleaveGroups(Array.from(doc.querySelectorAll('[data-reco-card]')));
        } catch (e) {
          return null;
        }
      };

      const relatedUrl = (id) => `${root}recommendations/products?product_id=${id}&limit=${fetchLimit}&intent=related&section_id=reco-items`;
      const usedRelated = new Set();
      const responses = await Promise.all(ids.map(async (id, i) => {
        if (logic === 'scent' && handles[i]) {
          const cards = await fetchCards(`${root}products/${encodeURIComponent(handles[i])}?section_id=reco-scent-items`);
          if (cards && cards.length) return cards;
        }
        usedRelated.add(id);
        return (await fetchCards(relatedUrl(id))) || [];
      }));

      // 商品ごとの結果を交互に並べる（1点目の関連商品だけで埋まらないように）
      const picked = [];
      const seen = new Set(exclude);
      const pickFrom = (lists) => {
        const maxLen = Math.max(0, ...lists.map((r) => r.length));
        for (let i = 0; i < maxLen && picked.length < limit; i++) {
          for (const cards of lists) {
            const card = cards[i];
            if (!card) continue;
            const pid = card.getAttribute('data-product-id');
            if (seen.has(pid)) continue;
            seen.add(pid);
            picked.push(card);
            if (picked.length >= limit) break;
          }
        }
      };
      pickFrom(responses);

      // カートページ（Aíam 2026-10-16 小松さん依頼）: 同じ香りの商品が足りず limit 件に届かないときは、
      // Search & Discovery の related で後ろを埋める（横スクロールが成り立つ件数にする）。商品ページは従来どおり
      if (picked.length < limit && this.getAttribute('context') === 'cart') {
        const fillIds = ids.filter((id) => !usedRelated.has(id));
        if (fillIds.length) pickFrom(await Promise.all(fillIds.map(async (id) => (await fetchCards(relatedUrl(id))) || [])));
      }

      // 商品名の語で除外したため（2026-10-27 フレグランス 8mL）まだ足りないときは、選んだカードの商品（先頭2件）の related でさらに埋める。
      // 8mL だけのカートでは、同じ香りと related の多くが 8mL で、3件程度まで減るため
      if (picked.length < limit && this.getAttribute('context') === 'cart' && this.hasAttribute('title-exclusions')) {
        const hopIds = picked.slice(0, 2).map((card) => card.getAttribute('data-product-id')).filter(Boolean);
        if (hopIds.length) pickFrom(await Promise.all(hopIds.map(async (id) => (await fetchCards(relatedUrl(id))) || [])));
      }

      if (picked.length === 0) return this.hideSelf();

      // 商品タイプで後ろに回す設定（2026-10-28 小松さん依頼。SHOP BAG などの資材を先頭に出さない）。外さずに並びだけ変える
      const demote = new Set((this.getAttribute('demote-types') || '').split(/[,、]/).map((s) => s.trim()).filter(Boolean));
      if (demote.size) {
        const isDemoted = (card) => demote.has((card.getAttribute('data-product-type') || '').trim());
        picked.splice(0, picked.length, ...picked.filter((card) => !isDemoted(card)), ...picked.filter(isDemoted));
      }

      const suffix = `-${RecoProducts.counter = (RecoProducts.counter || 0) + 1}`;
      const context = this.getAttribute('context') || 'product';
      const nodes = picked.map((card) => {
        const node = document.importNode(card, true);
        node.setAttribute('data-reco-context', context);
        node.querySelectorAll('[id^="reco-quick-buy-"]').forEach((el) => { el.id += suffix; });
        node.querySelectorAll('[aria-controls^="reco-quick-buy-"]').forEach((el) => { el.setAttribute('aria-controls', el.getAttribute('aria-controls') + suffix); });
        return node;
      });
      list.replaceChildren(...nodes);
      this.hidden = false;
      const wrapper = this.closest('[data-reco-wrapper]');
      if (wrapper) wrapper.hidden = false;
    }

    hideSelf() {
      this.hidden = true;
      const wrapper = this.closest('[data-reco-wrapper]');
      if (wrapper) wrapper.hidden = true;
    }
  }

  class RecoAddButton extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form) return;
      this.form.addEventListener('submit', (event) => this.onSubmit(event));

      // カード内の選択欄: 選んだバリエーションの画像に差し替え、追加済みの表示を戻す
      const select = this.form.querySelector('select[name="id"]');
      if (select) {
        select.addEventListener('change', () => {
          const option = select.selectedOptions[0];
          const image = option && option.getAttribute('data-image');
          const card = this.closest('.reco-card');
          const img = card && card.querySelector('.reco-card__media img');
          if (image && img) {
            img.removeAttribute('srcset');
            img.src = image;
          }
          const button = this.form.querySelector('button[type="submit"]');
          const label = button && button.querySelector('[data-reco-label]');
          if (button && button.classList.contains('is-added')) {
            button.classList.remove('is-added');
            if (label && this.defaultLabel) label.textContent = this.defaultLabel;
            const message = this.querySelector('[data-reco-message]');
            if (message) message.classList.remove('is-visible');
          }
        });
      }
    }

    async onSubmit(event) {
      event.preventDefault();
      const button = this.form.querySelector('button[type="submit"]');
      if (!button || button.getAttribute('aria-busy') === 'true') return;
      if (!this.form.checkValidity()) {
        this.form.reportValidity();
        return;
      }

      button.setAttribute('aria-busy', 'true');
      const sections = [];
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections } }));

      const formData = new FormData(this.form);
      if (sections.length) {
        formData.set('sections', sections.join(','));
        formData.set('sections_url', `${root}variants/${formData.get('id')}`);
      }

      let response;
      let json = {};
      try {
        response = await fetch(`${root}cart/add.js`, { method: 'POST', body: formData, headers: { 'X-Requested-With': 'XMLHttpRequest' } });
        json = await response.json();
      } catch (e) {
        response = { ok: false };
      }
      button.removeAttribute('aria-busy');

      const message = this.querySelector('[data-reco-message]');
      if (!response.ok) {
        if (message) {
          message.textContent = json.description || this.getAttribute('error-text') || '';
          message.classList.add('is-visible');
        }
        return;
      }

      if (window.themeVariables && window.themeVariables.settings.pageType === 'cart') {
        window.location.reload();
        return;
      }

      const cart = await (await fetch(`${root}cart.js`)).json();
      cart.sections = json.sections;
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
        bubbles: true,
        detail: { baseEvent: 'variant:add', cart }
      }));

      // eimy のヘッダーはカート件数を数字で出す（cart-dot の中身を Liquid で描画）。テーマは表示/非表示しか切り替えないので数字も更新する
      document.querySelectorAll('cart-dot').forEach((el) => {
        if (/^\d+$/.test(el.textContent.trim())) el.textContent = cart.item_count;
      });

      button.classList.add('is-added');
      const label = button.querySelector('[data-reco-label]');
      if (label && !this.defaultLabel) this.defaultLabel = label.textContent;
      if (label) label.textContent = this.getAttribute('added-text') || label.textContent;
      if (message) message.classList.add('is-visible');
    }
  }

  if (!customElements.get('reco-products')) customElements.define('reco-products', RecoProducts);
  if (!customElements.get('reco-add-button')) customElements.define('reco-add-button', RecoAddButton);
})();
